import type {
  SelectedRunFile,
  WandbRunFilePart,
} from '@wandb/forge-shell-contract/aria';

/** Use the same structured-reference path as run and panel attachments. */
export function runFilePart(file: SelectedRunFile): WandbRunFilePart {
  return {
    type: 'wandb-run-file',
    entityName: file.entityName,
    projectName: file.projectName,
    runName: file.runName,
    filePath: file.filePath,
  };
}
